/**
 * Debug logging for the frontend, mirroring the API's LOG_LEVEL approach:
 * verbose in dev, silent in production unless VITE_DEBUG=true is set at
 * build time. console.warn/error are never gated — real problems always show.
 */

function enabled(): boolean {
  return import.meta.env.DEV || import.meta.env.VITE_DEBUG === 'true';
}

export function debugLog(...args: unknown[]): void {
  if (enabled()) {
    console.log(...args);
  }
}
